var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{staticClass:"primary",attrs:{"app":""}},[_c('v-app-bar-title',{staticClass:"white--text text-no-wrap"},[_vm._v("\n    大交合 2.0\n  ")]),_c('v-spacer'),_c('mini-weather-card'),_c('settings-btn')],1)}
var staticRenderFns = []

export { render, staticRenderFns }